import { getAction } from '@/api/manage'

export function getDetail(params) {
  return getAction('/api/plugin/profit-report/profitReport/getDetail', params)
}